import { twMerge } from 'tailwind-merge';

import FileUploadDropzone from './FileUploadDropzone';
import FileUploadItem from './FileUploadItem';
import { FileUploadProps } from './types';

function FileUploadBase({ className, ...props }: FileUploadProps) {
  return (
    <div {...props} className={twMerge('flex flex-col gap-3', className)} />
  );
}

FileUploadBase.displayName = 'FileUpload';

export const FileUpload = Object.assign(FileUploadBase, {
  Dropzone: FileUploadDropzone,
  Item: FileUploadItem,
});
